import type { RenderDynamicBlockOptions } from './dynamic-block';
import { renderDynamicBlock } from './dynamic-block';
import { renderParagraph } from './paragraph';
import { renderTable } from './table';
import { renderTableOfContents } from './table-of-contents';
import { isRenderModelTOCEntry } from '../../slate-api';
import type { RenderModelContentBlock } from '../../slate-api';
import type { RenderNodeFnsOf } from '../engine/render-context';
import type { BaseRenderNodeOptions } from '../engine/rendering-data';

export interface RenderContentBlockOptions
  extends BaseRenderNodeOptions, RenderDynamicBlockOptions {}

export const renderContentBlockFns: RenderNodeFnsOf<
  RenderModelContentBlock,
  RenderContentBlockOptions
> = {
  'dynamic-block': renderDynamicBlock,
  instructionField: (renderContext, rMNodeEntry, options) => {
    if (!isRenderModelTOCEntry(rMNodeEntry)) return;
    renderTableOfContents(renderContext, rMNodeEntry, options);
  },
  paragraph: renderParagraph,
  table: renderTable,
};
